module.exports = __webpack_public_path__ + "static/3-e38e827a3ffcfb25289af07c06f2bba6.jpg";